var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_944)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99731 14.6615C11.6779 14.6615 14.6616 11.6778 14.6616 7.99718C14.6616 4.31659 11.6779 1.33289 7.99731 1.33289C4.31672 1.33289 1.33301 4.31659 1.33301 7.99718C1.33301 11.6778 4.31672 14.6615 7.99731 14.6615Z",
    stroke: "#0F172A",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99663 5.99792L5.99805 9.9965",
    stroke: "#0F172A",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99805 5.99792L9.99663 9.9965",
    stroke: "#0F172A",
    strokeWidth: 1.33286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_944"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9943,
    height: 15.9943,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose1);
export default __webpack_public_path__ + "static/media/Close1.4a23d29f3829050e081fa246994d5680.svg";
export { ForwardRef as ReactComponent };